/**
 * Draggable
 *
 * 指定された要素をマウスドラッグでスクロール可能にする機能を提供します。
 *
 * @param {string} element 対象要素のセレクター
 */
export function draggable(element) {
	let activeElement = null; // 現在ドラッグ中の要素を保持
	const elements = document.querySelectorAll(element);

	// 対象要素ごとにイベントリスナーを設定
	elements.forEach(el => {
		// マウスダウン時の処理
		el.addEventListener('mousedown', evt => {
			evt.preventDefault();
			activeElement = el;

			// ドラッグ開始時の情報をデータ属性に格納
			activeElement.dataset.isDragging = 'false';
			activeElement.dataset.startX = evt.clientX;
			activeElement.dataset.startY = evt.clientY;
			activeElement.dataset.scrollLeft = activeElement.scrollLeft;
			activeElement.dataset.scrollTop = activeElement.scrollTop;

			evt.stopPropagation();
		});

		// クリック時の処理（ドラッグでスクロールした場合はクリックイベントをキャンセル）
		el.addEventListener('click', evt => {
			if (activeElement?.dataset.isDragging === 'true') {
				evt.stopPropagation();
				evt.preventDefault();
			}
		});
	});

	// マウス移動時の処理
	document.addEventListener('mousemove', evt => {
		if (activeElement) {
			evt.preventDefault();

			// 現在のマウス位置と初期位置の差分を計算
			const deltaX = parseInt(activeElement.dataset.startX, 10) - evt.clientX;
			const deltaY = parseInt(activeElement.dataset.startY, 10) - evt.clientY;

			// 差分が0でない場合はドラッグ中と判定
			if (deltaX !== 0 || deltaY !== 0) {
				activeElement.dataset.isDragging = 'true';
			}

			// 要素のスクロール位置を更新
			activeElement.scrollLeft = parseInt(activeElement.dataset.scrollLeft, 10) + deltaX;
			activeElement.scrollTop = parseInt(activeElement.dataset.scrollTop, 10) + deltaY;

			evt.stopPropagation();
		}
	});

	// マウスアップ時の処理
	document.addEventListener('mouseup', evt => {
		if (activeElement) {
			// ドラッグ終了
			activeElement = null;
			evt.stopPropagation();
		}
	});
}
